import Department from "../../../../components/company/organization/department"

const DepartmentPage = () => {
    return <Department />
}

export default DepartmentPage;